import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { DATE_OPTIONS } from 'constants/filterOptions';
import 'setup/rc-calendar/index.css';
import 'setup/rc-calendar/custom.scss';
import { getDateRangeFromMonths } from 'lib/SearchFilterUtil';
import useFilterStore from 'zustandStore/useFilterStore';
import RpDateFilter from 'components/commons/RpDateFilter';

const DateFilter = React.memo(function DateFilter(props) {
    const date = useFilterStore(state => state.filters[props.comparableType][props.attr] || '');
    const setFilters = useFilterStore(state => state.setFilters);
    const isDefault = useFilterStore(state => state.isDefaultFilterValue);

    const isCustomDate = useMemo(() => {
        return date && !DATE_OPTIONS.some(
            option => getDateRangeFromMonths(option.value) === date
        );
    }, [date]);

    const handleChange = useCallback((value) => {
        setFilters(props.comparableType, { [props.attr]: value });
    }, [setFilters, props.comparableType, props.attr]);

    return (
        <RpDateFilter
            label={props.label}
            value={date}
            options={DATE_OPTIONS}
            onChange={handleChange}
            isCustomDate={isCustomDate}
            displayRight={props.displayRight}
            active={!isDefault(props.comparableType, props.attr, date)}
            width={props.width}
            fullWidth
            showValueAsTooltip
        />
    );
});

DateFilter.propTypes = {
    comparableType: PropTypes.string.isRequired,
    attr: PropTypes.string.isRequired,
    label: PropTypes.string,
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    displayRight: PropTypes.bool,
};

export default DateFilter;
